import MainProfileActions from 'components/main';
import { FC, useContext } from 'react';
import { CommentContext } from 'state/contexts/comment';
import { ActionTypes } from 'state/reducers/comment';
import Food from './food';
import ViewFood from './view-food';

type Props = {
  patientId: number;
  setPicturesTabUnreviewed: (value: boolean) => void;
};

const PicturesTab: FC<Props> = ({ patientId, setPicturesTabUnreviewed }) => {
  const { commentState, commentDispatch } = useContext(CommentContext);

  return (
    <>
      {/* activate all buttons from profile page */}
      <MainProfileActions key={`main-profile-buttons-${patientId}`} />

      <Food
        patientId={patientId}
        key={`food-${patientId}`}
        setPicturesTabUnreviewed={setPicturesTabUnreviewed}
      />

      {commentState.modal && (
        <ViewFood
          element_id={Number(commentState.element_id)}
          elements={commentState.elements}
          patientId={patientId}
          onClose={(element_id, elements) =>
            commentDispatch({
              type: ActionTypes.TOGGLE_MODAL,
              payload: { element_id, elements },
            })
          }
          callback={commentState.callback}
        />
      )}
    </>
  );
};

export default PicturesTab;
